export interface ProvenanceRawDetailProps {
  label?: string;
  value: unknown;
}

export function ProvenanceRawDetail({ label = 'Raw detail', value }: ProvenanceRawDetailProps): JSX.Element {
  return (
    <details>
      <summary className="cursor-pointer text-xs text-muted-foreground">{label}</summary>
      <pre className="mt-1 text-xs whitespace-pre-wrap break-all">{JSON.stringify(value, null, 2)}</pre>
    </details>
  );
}
